var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_4278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8728 20.2467C21.8809 21.7572 20.6628 22.9871 19.1532 22.9953C19.041 22.9962 18.9279 22.9898 18.8165 22.9763C17.4156 22.769 16.3893 21.55 16.4237 20.1345V3.86055C16.3902 2.4433 17.4192 1.22425 18.8211 1.01881C20.3207 0.843235 21.6791 1.91658 21.8547 3.41619C21.8674 3.5266 21.8737 3.63701 21.8728 3.74833V20.2467Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.725 17.5492C6.23004 17.5492 7.45 18.7692 7.45 20.2742C7.45 21.7792 6.23004 22.9992 4.725 22.9992C3.21996 22.9992 2 21.7792 2 20.2742C2 18.7692 3.21996 17.5492 4.725 17.5492ZM11.8945 9.29094C10.3822 9.37421 9.20935 10.6421 9.24464 12.1562V19.4751C9.24464 21.4616 10.1189 22.6671 11.3995 22.9241C12.8774 23.2236 14.3172 22.2689 14.6168 20.791C14.6539 20.61 14.672 20.4262 14.6711 20.2416V12.0295C14.6738 10.519 13.4521 9.29275 11.9416 9.29004C11.9262 9.29004 11.9099 9.29004 11.8945 9.29094Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_4278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8732,
    height: 22,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/googleAnalytics.67aa19a0e5f3e63108e843b590a84f43.svg";
export { ForwardRef as ReactComponent };